import PropTypes from 'prop-types';
import React from 'react';

function DigitSpinner ({number}) {
    const string = number.toString();
    let output = [];

    for (let i = 0, len = string.length; i < len; i += 1) {
        if (isNaN(string.charAt(i))) {
            output.push(<span className="digit-spinner__character"
                              key={ `digit-spinner-${i}` }>{ string.charAt(i) }</span>);
        } else {
            output.push(<span className="digit-spinner__digit digit-spinner__digit--animate"
                              key={ `digit-spinner-${i}` }
                              data-number={ string.charAt(i) }>
                <span>0</span>
                <span>1</span>
                <span>2</span>
                <span>3</span>
                <span>4</span>
                <span>5</span>
                <span>6</span>
                <span>7</span>
                <span>8</span>
                <span>9</span>
            </span>);
        }
    }

    return (
        <span className="digit-spinner" aria-hidden="true">
            { output }
        </span>
    );
}

DigitSpinner.propTypes = {
    number: PropTypes.string.isRequired
};

export default DigitSpinner;
